export default "__VITE_ASSET__88e1fb9d__"